import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { observer } from 'mobx-react-lite';
import { Platform } from 'react-native';

import {
  FiltersScreen,
  TutorialsScreen,
  TutorialScreen,
  ReportScreen,
  CommentScreen,
  CourseSummaryScreen,
  CoursesScreen,
} from '@screens';
import { screens } from './screens';
import type { HubStackParamListType } from './types';
import { Header, WebHeader } from '@components';

const HubStack = createNativeStackNavigator<HubStackParamListType>();

export const HubNavigator = observer(() => {
  return (
    <HubStack.Navigator
      screenOptions={{
        headerShown: true,
        header: (props) =>
          Platform.select({
            web: <WebHeader activeTabButtonName={screens.Hub} />,
            default: <Header {...props} />,
          }),
      }}
    >
      <HubStack.Screen
        component={FiltersScreen}
        name={screens.Filters}
        options={{ header: (props) => <Header {...props} /> }}
      />
      <HubStack.Screen
        component={TutorialScreen}
        name={screens.Tutorial}
        // When we will navigate to next/previous or tutorial from related list
        //  we will do this without animation
        options={{ animation: 'none' }}
      />
      <HubStack.Screen
        component={TutorialsScreen}
        name={screens.Tutorials}
      />
      <HubStack.Screen
        name={screens.Report}
        component={ReportScreen}
      />
      <HubStack.Screen
        name={screens.Comment}
        component={CommentScreen}
      />
      <HubStack.Screen
        component={CourseSummaryScreen}
        name={screens.CourseSummary}
      />
      <HubStack.Screen
        component={CoursesScreen}
        name={screens.Courses}
      />
    </HubStack.Navigator>
  );
});
